/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { SAMPLE_TO_SALE_SCREEN, COMMON } from '../../global/Constants';
import './sample-to-sale.css';
import ViewImage from '../common/ViewImage';
import Utilities from '../../global/Utilities';
import DataProvider from '../../providers/DataProvider';

class FruitQualityView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fruitQualityStage: {
                fruit_uniformity: "Good",
                fruit_color: "Green",
                fruit_length: "120",
                fruit_girth: "130",
                fruit_weight: 250,
                remark: "Remarks go here",
                images: ["../assets/images/krishak-info-img1.png", "../assets/images/krishak-info-img2.png"]
            }
        }
    }

    getFruitUniformity = (fruitUniformityId) => {
        const fruitUniformities = DataProvider.getInstance().getFruitUniformity();
        if (fruitUniformities) {
            const fruitUniformity = fruitUniformities.find(item => item.value === fruitUniformityId);
            Utilities.LogPrint(`fruitUniformity:`, fruitUniformity);
            return fruitUniformity?.label
        }
        return "";
    }


    render() {
        const { fruitQualityStage } = this.props;

        if (fruitQualityStage != null) {
            return (
                <div className="row">
                    <div className="col-12 px-sm-3">
                        <div className="row">
                            <div className="col-md-6 col-12">
                                <div className="row mb-2">
                                    <div className="col-md-12 col-4 pr-0 pr-md-3">
                                        Fruit Uniformity
                                    </div>
                                    <div className="col-md-12 col-8">
                                        <span className="d-block font-weight-medium">
                                            {this.getFruitUniformity(fruitQualityStage.fruit_uniformity)}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 col-12">
                                <div className="row mb-2">
                                    <div className="col-md-12 col-4 pr-0 pr-md-3">
                                        Fruit Color
                                    </div>
                                    <div className="col-md-12 col-8">
                                        <span className="d-block font-weight-medium">{fruitQualityStage.fruit_color}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 col-12">
                                <div className="row mb-2">
                                    <div className="col-md-12 col-4 pr-0 pr-md-3">
                                        Fruit Length
                                    </div>
                                    <div className="col-md-12 col-8">
                                        <span className="d-block font-weight-medium">{fruitQualityStage.fruit_length}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 col-12">
                                <div className="row mb-2">
                                    <div className="col-md-12 col-4 pr-0 pr-md-3">
                                        Fruit Girth
                                    </div>
                                    <div className="col-md-12 col-8">
                                        <span className="d-block font-weight-medium">{fruitQualityStage.fruit_girth}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 col-12">
                                <div className="row mb-2">
                                    <div className="col-md-12 col-4 pr-0 pr-md-3">
                                        Fruit Weight
                                    </div>
                                    <div className="col-md-12 col-8">
                                        <span className="d-block font-weight-medium">{fruitQualityStage.fruit_weight}</span>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="row m-md-0">
                            <hr className="w-100" />
                        </div>


                        <div className="row">
                            {/* Remarks Info */}
                            <div className="col-md-6 col-12 border-down">
                                <span className="d-flex w-100 align-items-center mt-1">
                                    {SAMPLE_TO_SALE_SCREEN.REMARKS}
                                </span>
                                <span className="d-flex font-weight-medium mb-2">{fruitQualityStage?.remark}</span>
                            </div>

                            {/* Images Info */}
                            {fruitQualityStage?.images?.length ?
                                <div className="col-md-6 col-12">
                                    <span className="font-weight-medium d-flex w-100 align-items-center mt-2 mb-2">{COMMON.IMAGES}</span>
                                    <div className="row row7-5 mb-3">
                                        {
                                            fruitQualityStage?.images.map((image, i) => (
                                                <ViewImage key={i} image={image.image_url} />
                                            ))
                                        }
                                    </div>
                                </div> : null
                            }

                        </div>
                    </div>
                </div>

            )
        } else {
            return null;
        }
    }
}

export default withRouter(FruitQualityView);